<template>
  <tr v-if="user" class="customer-item" style="cursor: pointer" @click="showModal = true">
    <td style="white-space: nowrap">
      <v-btn outline fab small class="extra-small" color="primary">
        <v-icon>list</v-icon>
      </v-btn>
    </td>
    <td>{{ user.uid ? user.uid : '-' }}</td>
    <td>{{ user.first_name ? user.first_name : '-' }}</td>
    <td>{{ user.th_name ? user.th_name : '-' }}</td>
    <td>{{ user.account_no ? user.account_no : '-' }}</td>
    <td>{{ user.id_no ? user.id_no : '-' }}</td>
    <td>{{ user.card_no ? user.card_no : '-' }}</td>

    <td>{{ user.prompt_pay ? user.prompt_pay : '-' }}</td>
    <td>{{ user.bank_name ? user.bank_name : '-' }}</td>
    <td>{{ user.bank_account_no ? user.bank_account_no : '-' }}</td>
    <td>
      <span v-html="handleGetStatusBankColor(user.bank_account_status)"></span>
    </td>

    <td>
      <span v-html="handleGetStatusColor(user.member_status)"></span>
    </td>

    <v-dialog v-model="showModal" width="800" persistent>
      <v-card>
        <div>
          <TicketMemberDetail v-if="showModal" :key="user.id" v-model="user">
            <div slot="header">
              <v-layout wrap>
                <v-flex xs3 class=""> </v-flex>
                <v-flex xs6 style="display: flex; align-items: center; justify-content: center">
                  <span class="white--text">ข้อมูลบัญชี</span>
                </v-flex>
                <v-flex xs3 class="text-xs-right">
                  <v-btn flat fab small class="extra-small" @click="showModal = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </TicketMemberDetail>
        </div>
      </v-card>
    </v-dialog>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import TicketMemberDetail from './TicketMemberDetail.vue'

export default {
  components: {
    TicketMemberDetail
  },
  props: ['value'],
  data: function () {
    return {
      user: undefined,
      showModal: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    value: function () {
      this.user = this.value
    }
  },
  mounted: function () {
    this.user = this.value
  },
  methods: {
    statusDisplay: function (value) {
      let status = ''
      if (value === 'active') {
        status = 'ผูกบัญชี'
      } else {
        status = 'ยกเลิกผูกบัญชี'
      }
      return status
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    handleGetStatusColor(status) {
      if (status) {
        let color = ''
        switch (status) {
          case 'active':
            color = 'success'
            break
          case 'inactive':
            color = 'error'
            break

          default:
            color = 'primary'
            break
        }
        let tmpStatus = ''
        if (status) {
          tmpStatus = this.statusDisplay(status)
          return `<span class="${color}--text">${tmpStatus}</span>`
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    statusBankDisplay: function (value) {
      let status = ''
      if (value.toLowerCase() === 'active') {
        status = 'เปิดใช้งาน'
      } else {
        status = 'รอการตรวจสอบ'
      }
      return status
    },
    handleGetStatusBankColor(status) {
      if (status) {
        let color = ''
        switch (status.toLowerCase()) {
          case 'active':
            color = 'success'
            break
          case 'waiting_to_approve':
            color = 'yellow'
            break

          default:
            color = 'primary'
            break
        }
        let tmpStatus = ''
        if (status) {
          tmpStatus = this.statusBankDisplay(status)
          return `<span class="${color}--text">${tmpStatus}</span>`
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/AiraAiful/MemberItem.vue